import './dashboard.scss';

import { MovementFeaturedList, TaskFeaturedList } from '@skinsoft/entity-ui';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Component } from 'vue-property-decorator';

import { Routes } from '../router';

@Component({
    components: {
        sMovementFeaturedList: MovementFeaturedList,
        sTaskFeaturedList: TaskFeaturedList,
    },
    template: require('./dashboard.html'),
})
export class Dashboard extends ReactiveVue {
    public Routes = Routes;
}
